import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-67ac9ae8"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  class: "notice-panel"
};
const _hoisted_3 = {
  class: "notice-heading"
};
const _hoisted_4 = {
  class: "notice-icon",
  "aria-hidden": "true"
};
const _hoisted_5 = {
  key: 0,
  class: "notice-feed"
};
const _hoisted_6 = ["onClick"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "notice-dot",
  "aria-hidden": "true"
}, null, -1));

const _hoisted_8 = {
  class: "notice-title"
};
const _hoisted_9 = {
  key: 1,
  class: "notice-empty"
};
const _hoisted_10 = ["aria-label"];
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { MenuOutlined, NotificationOutlined } from '@ant-design/icons-vue';
import { getHomePageCopy } from '@/util/homePageCopy';
export default {
  __name: 'HomeNotice',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  setup(__props) {
    const props = __props;
    const router = useRouter();
    const {
      locale
    } = useI18n();
    const copy = computed(() => getHomePageCopy(locale.value).notice);
    const visibleItems = computed(() => props.items.slice(0, 2));

    function openNotice(item) {
      router.push({
        name: 'bulletinDetail',
        query: {
          id: item.id
        }
      });
    }

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", {
        class: "home-notice",
        "aria-label": _unref(copy).title
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_createVNode(_unref(NotificationOutlined))]), _createElementVNode("strong", null, _toDisplayString(_unref(copy).title), 1)]), _unref(visibleItems).length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleItems), item => {
        return _openBlock(), _createElementBlock("button", {
          key: item.id,
          class: "notice-entry",
          type: "button",
          onClick: $event => openNotice(item)
        }, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)], 8, _hoisted_6);
      }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(copy).empty), 1)), _createElementVNode("button", {
        class: "notice-all",
        type: "button",
        "aria-label": _unref(copy).viewAll,
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push({
          name: 'bulletinList'
        }))
      }, [_createVNode(_unref(MenuOutlined), {
        "aria-hidden": "true"
      })], 8, _hoisted_10)])], 8, _hoisted_1);
    };
  }

};